import ContainerHorizontal from '../../atoms/container/cardHorizontalButtonContainer';
import ContainerVertical from '../../atoms/container/cardVerticalButtonContainer';
import InfoIcon from '../../atoms/icons/cardInfoIcon';
import PlanIcon from '../../atoms/icons/cardPlanIcon';
import PlayIcon from '../../atoms/icons/cardPlayIcon';
import { CardButtonIcon, CardType } from '../../../../shared/types/enums/card';
import DeviceConfig from '@devices/config';
import OpacityAnimation from '@components/utils/helpers/opacityAnimation';
import CardButtonText from '@components/atoms/text/cardButtonText';

interface Props {
  color?: string;
  focused?: boolean;
  text?: string;
  cardType?: CardType;
  iconType?: CardButtonIcon;
}

function CardButton({
  color,
  focused = false,
  text,
  cardType,
  iconType,
}: Props) {
  const vertical = cardType === CardType.VERTICAL;
  const Container = vertical ? ContainerVertical : ContainerHorizontal;
  let Icon = null;

  switch (iconType) {
    case CardButtonIcon.INFO:
      Icon = InfoIcon;
      break;
    case CardButtonIcon.PLAN:
      Icon = PlanIcon;
      break;
    case CardButtonIcon.PLAY:
      Icon = PlayIcon;
      break;
  }

  return (
    <OpacityAnimation delay={0}>
      <Container
        className={'button-focus'}
        color={color}
        focused={focused}
        animation={
          DeviceConfig.capabilities.disableAnimations ? '' : 'upgradable-plan'
        }
      >
        <CardButtonText vertical={vertical}>
          {text?.toUpperCase() || ''}
        </CardButtonText>
        {Icon ? (
          <Icon focused={focused} ratio={vertical ? 0.8 : undefined} />
        ) : null}
      </Container>
    </OpacityAnimation>
  );
}

export default CardButton;
